module.exports = __webpack_public_path__ + "img/xqhz.a1680623.jpg";